import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import DonationButton from './DonationButton';
import { Link, useLocation } from 'react-router-dom';
import { IoGlasses } from "react-icons/io5";
import Footer from './Footer';

function PdfFromImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const imagePromises = files.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(imagePromises).then(results => {
      setImages(prev => [...prev, ...results]);
    });
  };

  const createPDF = async () => {
    if (images.length === 0) return;
    
    setLoading(true);
    const pdf = new jsPDF();
    
    images.forEach((image, index) => {
      if (index > 0) pdf.addPage();
      const imgProps = pdf.getImageProperties(image);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(image, 'JPEG', 0, 0, pdfWidth, pdfHeight);
    });

    pdf.save('images.pdf');
    setLoading(false);
  };

  const location = useLocation();
  const isMainPage = location.pathname === '/';
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <header className="text-center">
        <Link to="/pdf-tools" className="text-4xl font-bold text-black">
          <div className="flex items-center gap-2 justify-center">
            <IoGlasses size={50} />
            PDF llama
          </div>
        </Link>
        {!isMainPage && (
          <>
            <div className="mt-1">
              <Link to="/pdf-tools" className="text-gray-600 hover:text-gray-800">
                Go to another operations with PDF
              </Link>
            </div>
          </>
        )}
      </header>
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 mt-2">

        <h1 className="text-3xl font-bold mb-6">Convert Images to PDF</h1>
        
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          // className="mb-4"
          className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-full file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
        />

        <div className="grid grid-cols-3 gap-4 mb-6">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Preview ${index + 1}`}
              className="w-full h-40 object-cover rounded-lg"
            />
          ))}
        </div>

        <button
          onClick={createPDF}
          disabled={loading || images.length === 0}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg mb-6 hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? 'Creating PDF...' : 'Create PDF'}
        </button>

      </div>
      <div className="mt-8">
        <DonationButton />
      </div>


      <article className="max-w-4xl mx-auto p-6">
      <h1 className="mb-6 font-semibold text-2xl">
        Convert images to PDF online: JPG, PNG, HEIC, etc.
      </h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          How to convert images to PDF online
        </h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium">Easy 3-step process:</h3>
          <div className="pl-4">
            <p className="mb-2">
              1. Upload your images (JPG, PNG, or other formats)
            </p>
            <p className="mb-2">
              2. Wait for the automatic conversion process
            </p>
            <p className="mb-2">
              3. Download your converted PDF file
            </p>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Benefits of our free image to PDF converter
        </h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium">Why choose PDF llama converter:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Free online converter with no registration required
            </li>
            <li>
              It's work instantly and doesn't send your confidential images to server
            </li>
            <li>
              Support for multiple image formats: JPG, PNG, WebP, HEIC, etc.
            </li>
            <li>
              Batch conversion — convert multiple images at once
            </li>
            <li>
              High-quality PDF output with original image resolution
            </li>
          </ul>
        </div>
      </section>

    </article>

    <Footer />

    </div>
  );
}

export default PdfFromImages;
